var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "row page-titles" }, [
      _c("div", { staticClass: "col-md-6 col-8 align-self-center" }, [
        _c("h3", { staticClass: "text-themecolor m-b-0 m-t-0" }, [
          _vm._v(_vm._s(_vm.trans("configuration.payment_configuration")))
        ]),
        _vm._v(" "),
        _c("ol", { staticClass: "breadcrumb" }, [
          _c(
            "li",
            { staticClass: "breadcrumb-item" },
            [
              _c("router-link", { attrs: { to: "/home" } }, [
                _vm._v(_vm._s(_vm.trans("general.home")))
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c("li", { staticClass: "breadcrumb-item active" }, [
            _vm._v(_vm._s(_vm.trans("configuration.payment_configuration")))
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-12" }, [
        _c("div", { staticClass: "card" }, [
          _c("div", { staticClass: "card-body" }, [
            _c(
              "form",
              {
                on: {
                  submit: function($event) {
                    $event.preventDefault()
                    return _vm.submit.apply(null, arguments)
                  },
                  keydown: function($event) {
                    return _vm.configForm.errors.clear($event.target.name)
                  }
                }
              },
              [
                _c("h4", { staticClass: "card-title" }, [
                  _vm._v(
                    _vm._s(_vm.trans("configuration.payment_configuration"))
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-12 col-md-4" }, [
                    _c("div", { staticClass: "form-group" }, [
                      _c("label", { attrs: { for: "" } }, [_vm._v("Paypal")]),
                      _vm._v(" "),
                      _c(
                        "div",
                        [
                          _c("switches", {
                            attrs: {
                              name: "subscription_paypal",
                              theme: "bootstrap",
                              color: "success"
                            },
                            model: {
                              value: _vm.configForm.subscription_paypal,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.configForm,
                                  "subscription_paypal",
                                  $$v
                                )
                              },
                              expression: "configForm.subscription_paypal"
                            }
                          })
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _vm.configForm.subscription_paypal
                      ? _c("div", [
                          _c("div", { staticClass: "form-group" }, [
                            _c("label", { attrs: { for: "" } }, [
                              _vm._v("Paypal Mode")
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              [
                                _c("switches", {
                                  attrs: {
                                    name: "subscription_paypal_mode",
                                    theme: "bootstrap",
                                    color: "success"
                                  },
                                  model: {
                                    value:
                                      _vm.configForm.subscription_paypal_mode,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.configForm,
                                        "subscription_paypal_mode",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "configForm.subscription_paypal_mode"
                                  }
                                })
                              ],
                              1
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "form-group" },
                            [
                              _c("label", { attrs: { for: "" } }, [
                                _vm._v("Paypal Client Id")
                              ]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value:
                                      _vm.configForm
                                        .subscription_paypal_client_id,
                                    expression:
                                      "configForm.subscription_paypal_client_id"
                                  }
                                ],
                                staticClass: "form-control",
                                attrs: {
                                  type: "text",
                                  name: "subscription_paypal_client_id",
                                  placeholder: "Paypal Client Id"
                                },
                                domProps: {
                                  value:
                                    _vm.configForm.subscription_paypal_client_id
                                },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.configForm,
                                      "subscription_paypal_client_id",
                                      $event.target.value
                                    )
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("show-error", {
                                attrs: {
                                  "form-name": _vm.configForm,
                                  "prop-name": "subscription_paypal_client_id"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "form-group" },
                            [
                              _c("label", { attrs: { for: "" } }, [
                                _vm._v("Paypal Client Secret")
                              ]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value:
                                      _vm.configForm
                                        .subscription_paypal_client_secret,
                                    expression:
                                      "configForm.subscription_paypal_client_secret"
                                  }
                                ],
                                staticClass: "form-control",
                                attrs: {
                                  type: "text",
                                  name: "subscription_paypal_client_secret",
                                  placeholder: "Paypal Client Secret"
                                },
                                domProps: {
                                  value:
                                    _vm.configForm
                                      .subscription_paypal_client_secret
                                },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.configForm,
                                      "subscription_paypal_client_secret",
                                      $event.target.value
                                    )
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("show-error", {
                                attrs: {
                                  "form-name": _vm.configForm,
                                  "prop-name":
                                    "subscription_paypal_client_secret"
                                }
                              })
                            ],
                            1
                          )
                        ])
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-12 col-md-4" }, [
                    _c("div", { staticClass: "form-group" }, [
                      _c("label", { attrs: { for: "" } }, [_vm._v("Stripe")]),
                      _vm._v(" "),
                      _c(
                        "div",
                        [
                          _c("switches", {
                            attrs: {
                              name: "subscription_stripe",
                              theme: "bootstrap",
                              color: "success"
                            },
                            model: {
                              value: _vm.configForm.subscription_stripe,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.configForm,
                                  "subscription_stripe",
                                  $$v
                                )
                              },
                              expression: "configForm.subscription_stripe"
                            }
                          })
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _vm.configForm.subscription_stripe
                      ? _c("div", [
                          _c("div", { staticClass: "form-group" }, [
                            _c("label", { attrs: { for: "" } }, [
                              _vm._v("Stripe Mode")
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              [
                                _c("switches", {
                                  attrs: {
                                    name: "subscription_stripe_mode",
                                    theme: "bootstrap",
                                    color: "success"
                                  },
                                  model: {
                                    value:
                                      _vm.configForm.subscription_stripe_mode,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.configForm,
                                        "subscription_stripe_mode",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "configForm.subscription_stripe_mode"
                                  }
                                })
                              ],
                              1
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "form-group" },
                            [
                              _c("label", { attrs: { for: "" } }, [
                                _vm._v("Stripe Publishable Key")
                              ]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value:
                                      _vm.configForm
                                        .subscription_stripe_publishable_key,
                                    expression:
                                      "configForm.subscription_stripe_publishable_key"
                                  }
                                ],
                                staticClass: "form-control",
                                attrs: {
                                  type: "text",
                                  name: "subscription_stripe_publishable_key",
                                  placeholder: "Stripe Publishable Key"
                                },
                                domProps: {
                                  value:
                                    _vm.configForm
                                      .subscription_stripe_publishable_key
                                },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.configForm,
                                      "subscription_stripe_publishable_key",
                                      $event.target.value
                                    )
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("show-error", {
                                attrs: {
                                  "form-name": _vm.configForm,
                                  "prop-name":
                                    "subscription_stripe_publishable_key"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "form-group" },
                            [
                              _c("label", { attrs: { for: "" } }, [
                                _vm._v("Stripe Private Key")
                              ]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value:
                                      _vm.configForm
                                        .subscription_stripe_private_key,
                                    expression:
                                      "configForm.subscription_stripe_private_key"
                                  }
                                ],
                                staticClass: "form-control",
                                attrs: {
                                  type: "text",
                                  name: "subscription_stripe_private_key",
                                  placeholder: "Stripe Private Key"
                                },
                                domProps: {
                                  value:
                                    _vm.configForm
                                      .subscription_stripe_private_key
                                },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.configForm,
                                      "subscription_stripe_private_key",
                                      $event.target.value
                                    )
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("show-error", {
                                attrs: {
                                  "form-name": _vm.configForm,
                                  "prop-name": "subscription_stripe_private_key"
                                }
                              })
                            ],
                            1
                          )
                        ])
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-12 col-md-4" }, [
                    _c("div", { staticClass: "form-group" }, [
                      _c("label", { attrs: { for: "" } }, [_vm._v("Razorpay")]),
                      _vm._v(" "),
                      _c(
                        "div",
                        [
                          _c("switches", {
                            attrs: {
                              name: "subscription_razorpay",
                              theme: "bootstrap",
                              color: "success"
                            },
                            model: {
                              value: _vm.configForm.subscription_razorpay,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.configForm,
                                  "subscription_razorpay",
                                  $$v
                                )
                              },
                              expression: "configForm.subscription_razorpay"
                            }
                          })
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _vm.configForm.subscription_razorpay
                      ? _c("div", [
                          _c("div", { staticClass: "form-group" }, [
                            _c("label", { attrs: { for: "" } }, [
                              _vm._v("Razorpay Mode")
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              [
                                _c("switches", {
                                  attrs: {
                                    name: "subscription_razorpay_mode",
                                    theme: "bootstrap",
                                    color: "success"
                                  },
                                  model: {
                                    value:
                                      _vm.configForm.subscription_razorpay_mode,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.configForm,
                                        "subscription_razorpay_mode",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "configForm.subscription_razorpay_mode"
                                  }
                                })
                              ],
                              1
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "form-group" },
                            [
                              _c("label", { attrs: { for: "" } }, [
                                _vm._v("Razorpay Publishable Key")
                              ]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value:
                                      _vm.configForm
                                        .subscription_razorpay_publishable_key,
                                    expression:
                                      "configForm.subscription_razorpay_publishable_key"
                                  }
                                ],
                                staticClass: "form-control",
                                attrs: {
                                  type: "text",
                                  name: "subscription_razorpay_publishable_key",
                                  placeholder: "Razorpay Publishable Key"
                                },
                                domProps: {
                                  value:
                                    _vm.configForm
                                      .subscription_razorpay_publishable_key
                                },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.configForm,
                                      "subscription_razorpay_publishable_key",
                                      $event.target.value
                                    )
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("show-error", {
                                attrs: {
                                  "form-name": _vm.configForm,
                                  "prop-name":
                                    "subscription_razorpay_publishable_key"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "form-group" },
                            [
                              _c("label", { attrs: { for: "" } }, [
                                _vm._v("Razorpay Private Key")
                              ]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value:
                                      _vm.configForm
                                        .subscription_razorpay_private_key,
                                    expression:
                                      "configForm.subscription_razorpay_private_key"
                                  }
                                ],
                                staticClass: "form-control",
                                attrs: {
                                  type: "text",
                                  name: "subscription_razorpay_private_key",
                                  placeholder: "Razorpay Private Key"
                                },
                                domProps: {
                                  value:
                                    _vm.configForm
                                      .subscription_razorpay_private_key
                                },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.configForm,
                                      "subscription_razorpay_private_key",
                                      $event.target.value
                                    )
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("show-error", {
                                attrs: {
                                  "form-name": _vm.configForm,
                                  "prop-name":
                                    "subscription_razorpay_private_key"
                                }
                              })
                            ],
                            1
                          )
                        ])
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-12 col-md-4" }, [
                    _c("div", { staticClass: "form-group" }, [
                      _c("label", { attrs: { for: "" } }, [
                        _vm._v("Two Checkout")
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        [
                          _c("switches", {
                            attrs: {
                              name: "subscription_two_checkout",
                              theme: "bootstrap",
                              color: "success"
                            },
                            model: {
                              value: _vm.configForm.subscription_two_checkout,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.configForm,
                                  "subscription_two_checkout",
                                  $$v
                                )
                              },
                              expression: "configForm.subscription_two_checkout"
                            }
                          })
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _vm.configForm.subscription_two_checkout
                      ? _c("div", [
                          _c("div", { staticClass: "form-group" }, [
                            _c("label", { attrs: { for: "" } }, [
                              _vm._v("Two Checkout Mode")
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              [
                                _c("switches", {
                                  attrs: {
                                    name: "subscription_checkout_mode",
                                    theme: "bootstrap",
                                    color: "success"
                                  },
                                  model: {
                                    value:
                                      _vm.configForm.subscription_checkout_mode,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.configForm,
                                        "subscription_checkout_mode",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "configForm.subscription_checkout_mode"
                                  }
                                })
                              ],
                              1
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "form-group" },
                            [
                              _c("label", { attrs: { for: "" } }, [
                                _vm._v("Two Checkout Seller Id")
                              ]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value:
                                      _vm.configForm
                                        .subscription_two_checkout_seller_id,
                                    expression:
                                      "configForm.subscription_two_checkout_seller_id"
                                  }
                                ],
                                staticClass: "form-control",
                                attrs: {
                                  type: "text",
                                  name: "subscription_two_checkout_seller_id",
                                  placeholder: "Two Checkout Seller Id"
                                },
                                domProps: {
                                  value:
                                    _vm.configForm
                                      .subscription_two_checkout_seller_id
                                },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.configForm,
                                      "subscription_two_checkout_seller_id",
                                      $event.target.value
                                    )
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("show-error", {
                                attrs: {
                                  "form-name": _vm.configForm,
                                  "prop-name":
                                    "subscription_two_checkout_seller_id"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "form-group" },
                            [
                              _c("label", { attrs: { for: "" } }, [
                                _vm._v("Two Checkout Publishable Key")
                              ]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value:
                                      _vm.configForm
                                        .subscription_two_checkout_publishable_key,
                                    expression:
                                      "configForm.subscription_two_checkout_publishable_key"
                                  }
                                ],
                                staticClass: "form-control",
                                attrs: {
                                  type: "text",
                                  name:
                                    "subscription_two_checkout_publishable_key",
                                  placeholder: "Two Checkout Publishable Key"
                                },
                                domProps: {
                                  value:
                                    _vm.configForm
                                      .subscription_two_checkout_publishable_key
                                },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.configForm,
                                      "subscription_two_checkout_publishable_key",
                                      $event.target.value
                                    )
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("show-error", {
                                attrs: {
                                  "form-name": _vm.configForm,
                                  "prop-name":
                                    "subscription_two_checkout_publishable_key"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "form-group" },
                            [
                              _c("label", { attrs: { for: "" } }, [
                                _vm._v("Two Checkout Private Key")
                              ]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value:
                                      _vm.configForm
                                        .subscription_two_checkout_private_key,
                                    expression:
                                      "configForm.subscription_two_checkout_private_key"
                                  }
                                ],
                                staticClass: "form-control",
                                attrs: {
                                  type: "text",
                                  name: "subscription_two_checkout_private_key",
                                  placeholder: "Two Checkout Private Key"
                                },
                                domProps: {
                                  value:
                                    _vm.configForm
                                      .subscription_two_checkout_private_key
                                },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.configForm,
                                      "subscription_two_checkout_private_key",
                                      $event.target.value
                                    )
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("show-error", {
                                attrs: {
                                  "form-name": _vm.configForm,
                                  "prop-name":
                                    "subscription_two_checkout_private_key"
                                }
                              })
                            ],
                            1
                          )
                        ])
                      : _vm._e()
                  ])
                ]),
                _vm._v(" "),
                _c("h4", { staticClass: "card-title" }, [
                  _vm._v(
                    _vm._s(_vm.trans("configuration.invoice_configuration"))
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-12 col-sm-4" }, [
                    _c(
                      "div",
                      { staticClass: "form-group" },
                      [
                        _c("label", { attrs: { for: "" } }, [
                          _vm._v(
                            _vm._s(
                              _vm.trans(
                                "configuration.subscription_invoice_prefix"
                              )
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.configForm.subscription_invoice_prefix,
                              expression:
                                "configForm.subscription_invoice_prefix"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: {
                            type: "text",
                            name: "subscription_invoice_prefix",
                            placeholder: _vm.trans(
                              "configuration.subscription_invoice_prefix"
                            )
                          },
                          domProps: {
                            value: _vm.configForm.subscription_invoice_prefix
                          },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.configForm,
                                "subscription_invoice_prefix",
                                $event.target.value
                              )
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("show-error", {
                          attrs: {
                            "form-name": _vm.configForm,
                            "prop-name": "subscription_invoice_prefix"
                          }
                        })
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-12 col-sm-4" }, [
                    _c(
                      "div",
                      { staticClass: "form-group" },
                      [
                        _c("label", { attrs: { for: "" } }, [
                          _vm._v(
                            _vm._s(
                              _vm.trans(
                                "configuration.subscription_invoice_number_digit"
                              )
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value:
                                _vm.configForm
                                  .subscription_invoice_number_digit,
                              expression:
                                "configForm.subscription_invoice_number_digit"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: {
                            type: "text",
                            name: "subscription_invoice_number_digit",
                            placeholder: _vm.trans(
                              "configuration.subscription_invoice_number_digit"
                            )
                          },
                          domProps: {
                            value:
                              _vm.configForm.subscription_invoice_number_digit
                          },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.configForm,
                                "subscription_invoice_number_digit",
                                $event.target.value
                              )
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("show-error", {
                          attrs: {
                            "form-name": _vm.configForm,
                            "prop-name": "subscription_invoice_number_digit"
                          }
                        })
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-12 col-sm-4" }, [
                    _c(
                      "div",
                      { staticClass: "form-group" },
                      [
                        _c("label", { attrs: { for: "" } }, [
                          _vm._v(
                            _vm._s(
                              _vm.trans(
                                "configuration.subscription_invoice_start_number"
                              )
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value:
                                _vm.configForm
                                  .subscription_invoice_start_number,
                              expression:
                                "configForm.subscription_invoice_start_number"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: {
                            type: "text",
                            name: "subscription_invoice_start_number",
                            placeholder: _vm.trans(
                              "configuration.subscription_invoice_start_number"
                            )
                          },
                          domProps: {
                            value:
                              _vm.configForm.subscription_invoice_start_number
                          },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.configForm,
                                "subscription_invoice_start_number",
                                $event.target.value
                              )
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("show-error", {
                          attrs: {
                            "form-name": _vm.configForm,
                            "prop-name": "subscription_invoice_start_number"
                          }
                        })
                      ],
                      1
                    )
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c("label", { attrs: { for: "" } }, [
                      _vm._v(
                        _vm._s(
                          _vm.trans("configuration.subscription_invoice_tnc")
                        )
                      )
                    ]),
                    _vm._v(" "),
                    _c("html-editor", {
                      attrs: {
                        name: "subscription_invoice_tnc",
                        model: _vm.configForm.subscription_invoice_tnc,
                        isUpdate: _vm.updateTnc
                      },
                      on: {
                        "update:model": function($event) {
                          return _vm.$set(
                            _vm.configForm,
                            "subscription_invoice_tnc",
                            $event
                          )
                        },
                        clearErrors: function($event) {
                          return _vm.configForm.errors.clear(
                            "subscription_invoice_tnc"
                          )
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("show-error", {
                      attrs: {
                        "form-name": _vm.configForm,
                        "prop-name": "subscription_invoice_tnc"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass:
                      "btn btn-info waves-effect waves-light pull-right m-t-10",
                    attrs: { type: "submit" }
                  },
                  [_vm._v(_vm._s(_vm.trans("general.save")))]
                )
              ]
            )
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }